import React, { Component } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";

class DatePickerEditor extends Component {
  state = {
    selectedDate: moment(this.props.value),
  };

  isPopup() {
    return true;
  }

  getValue() {
    return this.state.selectedDate;
  }

  handleChange = date => {
    const selectedDate = date;
    this.setState(() => ({ selectedDate }));
  };

  render() {
    // console.debug(this.props);
    return (
      <DatePicker
        selected={this.state.selectedDate}
        onChange={this.handleChange}
      />
    );
  }
}

export default DatePickerEditor;
